import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";
import Routing from "../../../../Routing.ts";

export default function FortrydelsesretArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <p>
                            Du har altid 14 dages fortrydelsesret fra du modtager ordrebekræftelsen fra os.
                            Hvis du vil fortryde skal du bruge fortrydelsesformularen som du finder <Link to={Routing.About.Conditions}>her</Link>.
                            Du kan også ringe til os på <a href="tel:+4588772000">88&nbsp;77&nbsp;20&nbsp;00</a> eller kontakte os via vores <Link to={Routing.Contact.Index}>kontaktside</Link>.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "mit-abonnement",
                        "article": "skal-du-flytte",
                        "name": "Skal du flytte?"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "overdrag-dit-internet-til-anden-person",
                        "name": "Overdrag dit internet til en anden"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "returner-udstyr",
                        "name": "Hvordan returnerer jeg mit udstyr?"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "bindingsperiode",
                        "name": "Hvor lang er min bindingsperiode"
                    }
                ]}
            />
        </>
    )
}
